import { Outlet } from "react-router-dom";
import { labelCopyRight } from "../../_constants";

export const BackgroundLayout = () => {
  return (
    <main className="bg-image">
      <Outlet />
      <footer className="footer text-sm white">{labelCopyRight}</footer>
    </main>
  );
};
